import React, { FunctionComponent } from 'react'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { Divider } from '../../atoms/divider/Divider'
import { SummaryDetail, SummaryDetailProps } from '../../atoms/summaryDetail/SummaryDetail'
import { BodyTextSize } from '../../styles/typeStyles'

export type SummaryDetailsProps = {
  summaryDetails: SummaryDetailProps[]
  keyPrefix: string
  additionalInfo?: React.ReactNode
}

const SummaryDetailsContainer = styled.View(({ theme: { spacing, colors } }) => ({
  borderRadius: spacing['16px'],
  padding: spacing['24px'],
  backgroundColor: colors.backgroundElement,
  display: 'flex',
  flexDirection: 'column',
  gap: spacing['16px'],
}))

const SummaryDetailsRow = styled.View({
  flexDirection: 'row',
})

const AdditionalInfo: FunctionComponent<{ additionalInfo?: React.ReactNode; keyPrefix: string }> = ({
  additionalInfo,
  keyPrefix,
}) => {
  const { colors } = useTheme()

  if (!additionalInfo) {
    return null
  }

  return (
    <>
      <Divider />
      <BodyText color={colors.textSecondary} size={BodyTextSize.DEFAULT} testID={`${keyPrefix}-additionalInfo`}>
        {additionalInfo}
      </BodyText>
    </>
  )
}

export const SummaryDetails: FunctionComponent<SummaryDetailsProps> = ({
  summaryDetails = [],
  keyPrefix,
  additionalInfo = '',
}) => {
  return (
    <SummaryDetailsContainer>
      <SummaryDetailsRow>
        {summaryDetails.map((summaryDetail, index) => (
          <SummaryDetail key={`${keyPrefix}-summary-detail-${index}`} {...summaryDetail} />
        ))}
      </SummaryDetailsRow>
      <AdditionalInfo additionalInfo={additionalInfo} keyPrefix={keyPrefix} />
    </SummaryDetailsContainer>
  )
}
